module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    ref: "modal"
  }, [_c('span', {
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_vm._t("activator")], 2), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Mark product as Delivered")]), _vm._v(" "), _c('div', {
    staticClass: "header"
  }, [_c('h2', [_vm._t("header")], 2)]), _vm._v(" "), _c('div', {
    staticClass: "toolbar"
  }, [_vm._t("toolbar")], 2), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "infos"
  }, [_c('div', [_vm._v("Order N°" + _vm._s(_vm.order.id_order))]), _vm._v(" "), _c('div', [_vm._v("Product id N° " + _vm._s(_vm.value.id_product))])]), _vm._v(" "), _c('div', {
    staticClass: "product-status-form"
  }, [_c('div', {
    staticClass: "center aligned"
  }, [_c('button', {
    staticClass: "ui button green",
    attrs: {
      "disabled": _vm.loading === true
    },
    on: {
      "click": function($event) {
        _vm.showModal = true
      }
    }
  }, [_vm._v("\n          Mark product as Delivered\n        ")])])])]), _vm._v(" "), _c('popup-modal', {
    ref: "confirmProductStatusModal",
    attrs: {
      "index": _vm.showModal,
      "icon": "checkmark",
      "cancel_class": "ui red basic cancel inverted button",
      "confirm_class": "ui green ok inverted button",
      "text": "Are you sure you want to mark this product as Delivered ?"
    },
    on: {
      "delete": function($event) {
        return _vm.updateProductStatus()
      },
      "cancel": function($event) {
        _vm.showModal = null
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2463332e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProductStatusModal.vue
// module id = 484
// module chunks = 1